import { computed } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useLeadStore, useTenantInMarketStore } from '../..';
import useTenantsInMarketWithFocusArea from '../../hooks/useTenantsInMarketWithFocusArea';
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import useTenantsInMarketWithGlobalFilters from '../../interfaces/useTenantsInMarketWithGlobalFilters';
import GeometryService from '../../services/geometryService';
import TenantsInMarketGrid from '../tenantsInMarket/TenantsInMarketGrid';

function LeadDetailsTenantsInMarketTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { id } = useParams();
    const leadStore = useLeadStore();
    const tenantInMarketStore = useTenantInMarketStore();
    const lead = useMemo(() => computed(() => leadStore.leads.find(l => l.id.toString() === id)!), [id]).get();
    const geometryService = useMemo(() => new GeometryService(), []);
    const tenantsInMarket = useTenantsInMarketWithFocusArea(useTenantsInMarketWithGlobalFilters(
        useMemo(() => computed(() => tenantInMarketStore.tenantsInMarket.filter(tim => geometryService.isPointInsideShape(lead.centerPoint, tim.shape))), [lead]).get()
    ));

    useEffect(() => setEntityCount(tenantsInMarket.length), [tenantsInMarket]);

    if (!visible)
        return null;

    return <TenantsInMarketGrid tenantsInMarket={tenantsInMarket} />;
}

export default observer(LeadDetailsTenantsInMarketTab);
